module.exports = __webpack_public_path__ + "public/images/about-16.7c8f678b1e66702557aa828595731fbd.png";